import {
    Box as UiBox,
    IconButton,
    Modal,
    styled,
} from "@l2r-front/l2r-ui"

const BUTTON_SIZE = 44

export const FabButton = styled(IconButton)(({ theme }) => ({
    backgroundColor: theme.palette["surfaces/surface-primary"].main,
    boxShadow: theme.shadows[3],
    width: BUTTON_SIZE,
    height: BUTTON_SIZE,

    "&:hover": {
        backgroundColor: theme.palette["objects/object-lightgrey"].main,
    },
}))

export const Popup = styled(Modal)(({ theme }) => ({
    backgroundColor: theme.palette["surfaces/surface-primary"].main,
    width: "100%",
    height: "100%",
}))

export const Box = styled(UiBox)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    position: "relative",
    padding: theme.spacing(6),
    height: "100%",
}))